@import '../../../utils/global.module.less';

.panelRowDivier {
    height: 10px;
    background-color: #eaecf0;
    width: 100%;
}
